import { render, staticRenderFns } from "./ProyectosNuevo.vue?vue&type=template&id=423429cd&scoped=true"
import script from "./ProyectosNuevo.vue?vue&type=script&lang=js"
export * from "./ProyectosNuevo.vue?vue&type=script&lang=js"
import style0 from "./ProyectosNuevo.vue?vue&type=style&index=0&id=423429cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423429cd",
  null
  
)

export default component.exports